export enum EPLITrainerStatus {
  NewApplicant = 'New Applicant',
  InactiveEpliTrainer = 'Inactive EPLI Trainer of START Content',
  CurrentEpliTrainer = 'Current EPLI Trainer of START Content',
  CoachLeader = 'Coach Leader'
}
